import { DrawerKey } from 'stores/DrawersStore'
import { useRootStore } from 'stores/RootStore'

const TAB_LIKE_DRAWER_KEYS: ReadonlyArray<DrawerKey> = ['backgrounds', 'templates', 'elements', 'text']

export const useBlankFrameHints = () => {
  const { designStore, drawersStore } = useRootStore()

  if (!designStore) {
    return false
  }

  const { editor } = designStore

  if (editor.getInstanceState().isReadonly) {
    return false
  }

  const processingShape = designStore.processingShapeId && editor.getShape(designStore.processingShapeId)
  const currentTab = designStore.tab

  return (
    !processingShape &&
    currentTab &&
    !['templates', 'text', 'elements', 'uploads', 'backgrounds'].includes(currentTab) &&
    !drawersStore.drawers.some((drawer) => drawer.drawerKey && TAB_LIKE_DRAWER_KEYS.includes(drawer.drawerKey)) &&
    !(editor.getOnlySelectedShape()?.type === 'frame')
  )
}
